import * as React from "react"
const SvgDevicesDesktopMobile = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M3.5 20.571q-.625 0-1.063-.437A1.45 1.45 0 0 1 2 19.07q0-.624.438-1.062A1.45 1.45 0 0 1 3.5 17.57H4v-11q0-.824.588-1.412A1.93 1.93 0 0 1 6 4.57h14q.424 0 .712.288.288.289.288.712a.97.97 0 0 1-.288.713.97.97 0 0 1-.712.287H6v11h4.5q.624 0 1.063.438.437.438.437 1.062t-.438 1.063a1.45 1.45 0 0 1-1.062.437h-7Zm11.5 0a.97.97 0 0 1-.713-.287.97.97 0 0 1-.287-.713v-10a.97.97 0 0 1 .287-.712A.97.97 0 0 1 15 8.57h6q.424 0 .712.288T22 9.57v10a.97.97 0 0 1-.288.713.97.97 0 0 1-.712.287h-6Zm1-3h4v-7h-4z" />
  </svg>
)
export default SvgDevicesDesktopMobile
